export enum BalanceFilterType {
  ALL = 'ALL',
  INCOME = 'INCOME',
  EXPENSE = 'EXPENSE',
}
